"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishTransaction = void 0;
const consts_1 = require("../../consts");
const u_1 = require("../../u");
const BaseTransaction_1 = require("./BaseTransaction");
const TransactionType_1 = __importDefault(require("./TransactionType"));
class PublishTransaction extends BaseTransaction_1.BaseTransaction {
    constructor(obj = {}) {
        super(Object.assign({ version: consts_1.TX_VERSION.PUBLISH }, obj));
        this.type = TransactionType_1.default.PublishTransaction;
        this.script = obj.script || "";
        this.parameterList = obj.parameterList || [0];
        this.returnType = obj.returnType || 0;
        this.needStorage = obj.needStorage || false;
        this.name = obj.name || "";
        this.codeVersion = obj.codeVersion || "";
        this.author = obj.author || "";
        this.email = obj.email || "";
        this.description = obj.description || "";
    }
    static deserializeExclusive(ss, tx) {
        if (tx.version === undefined) {
            tx.version = 0;
        }
        if (tx.version > 1) {
            throw new Error(`version need to be less or equal than 1. Got ${tx.version}`);
        }
        const script = ss.readVarBytes();
        const paramList = ss.readVarBytes();
        const parameterList = [];
        for (let i = 0; i + 2 <= paramList.length; i = i + 2) {
            parameterList.push(parseInt(paramList.substring(i, i + 2), 16));
        }
        const returnType = parseInt(ss.read(1), 16);
        if (tx.version >= 1) {
            throw new Error(`version need to be less or equal than 1. Got ${tx.version}`);
        }
        // eslint-disable-next-line @typescript-eslint/naming-convention
        let NeedStorage = false;
        if (tx.version >= 1) {
            NeedStorage = !!parseInt(ss.read(1), 16);
        }
        const name = u_1.hexstring2str(ss.readVarBytes());
        const codeVersion = u_1.hexstring2str(ss.readVarBytes());
        const author = u_1.hexstring2str(ss.readVarBytes());
        const email = u_1.hexstring2str(ss.readVarBytes());
        const description = u_1.hexstring2str(ss.readVarBytes());
        return Object.assign(tx, {
            script,
            parameterList,
            returnType,
            NeedStorage,
            name,
            codeVersion,
            author,
            email,
            description,
        });
    }
    get exclusiveData() {
        return {
            script: this.script,
            parameterList: this.parameterList,
            returnType: this.returnType,
            needStorage: this.needStorage,
            name: this.name,
            codeVersion: this.codeVersion,
            author: this.author,
            email: this.email,
            description: this.description,
        };
    }
    get fees() {
        return 0;
    }
    serializeExclusive() {
        let out = u_1.num2VarInt(this.script.length / 2);
        out += this.script;
        out += u_1.num2VarInt(this.parameterList.length);
        out += u_1.ab2hexstring(this.parameterList);
        if (this.version >= 1) {
            out += u_1.num2hexstring(this.needStorage ? 1 : 0, 1);
        }
        out += u_1.num2VarInt(this.returnType);
        out += u_1.num2VarInt(this.name.length);
        out += u_1.str2hexstring(this.name);
        out += u_1.num2VarInt(this.codeVersion.length);
        out += u_1.str2hexstring(this.codeVersion);
        out += u_1.num2VarInt(this.author.length);
        out += u_1.str2hexstring(this.author);
        out += u_1.num2VarInt(this.email.length);
        out += u_1.str2hexstring(this.email);
        out += u_1.num2VarInt(this.description.length);
        out += u_1.str2hexstring(this.description);
        return out;
    }
    equals(other) {
        if (this.type !== other.type) {
            return false;
        }
        if (other instanceof PublishTransaction) {
            return this.hash === other.hash;
        }
        return this.hash === new PublishTransaction(other).hash;
    }
    export() {
        return Object.assign(super.export(), {
            script: this.script,
            parameterList: this.parameterList,
            returnType: this.returnType,
            needStorage: this.needStorage,
            name: this.name,
            codeVersion: this.codeVersion,
            author: this.author,
            email: this.email,
            description: this.description,
        });
    }
}
exports.PublishTransaction = PublishTransaction;
exports.default = PublishTransaction;
